/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { Fragment, useContext } from "react"
import { Cookies } from 'react-cookie-consent';
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useQueryParam, NumberParam } from "use-query-params"
import { myContext } from "../context/Provider"

function Seo({
  description,
  socialDescription,
  meta,
  title,
  socialTitle,
  noindex,
  schema,
  spanish,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            canonicalUrl
            image
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const image = site.siteMetadata.image
  const context = useContext(myContext)
  const [showcookie] = useQueryParam("showcookie", NumberParam)

  return (
    <Helmet
      htmlAttributes={{
        lang: spanish ? "es" : "en",
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: socialTitle || title,
        },
        {
          property: `og:description`,
          content: socialDescription || metaDescription,
        },
        {
          name: `og:image`,
          content: image,
        },
        {
          name: `twitter:title`,
          content: socialTitle || title,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:image`,
          content: image,
        },
        {
          name: `twitter:description`,
          content: socialDescription || metaDescription,
        },
        {
          name: `facebook-domain-verification`,
          content: "oau6gj6ambbks06omsbhqfg57rfzqc",
        },
      ].concat(meta)}
    >
      {showcookie === 0 ? (
        ""
      ) : (
        <script
          src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
          type="text/javascript"
          charSet="UTF-8"
          data-domain-script="019403d2-373c-7da4-84ec-a1bc9e82a325-test"
        ></script>
      )}
      {showcookie === 0 ? (
        ""
      ) : (
        <script type="text/javascript">
          {`function OptanonWrapper() {
            document.querySelector("#ot-sdk-btn-floating").style.display = 'none';
          }`}
        </script>
      )}
      <link rel="icon" type="image/x-icon" href="favicon.ico" />
      {noindex && <meta name="robots" content="noindex" />}
      <script
        type="module"
        id="rxscript"
        src={`https://in.rxengage.app/rxdefine.js/rxdefine.js?id=${context.rxDefineId}`}
        data-react-helmet="true"
      />
      {schema && <script type="application/ld+json">{schema}</script>}
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
}

export default Seo
